
import { Component } from 'react';
import { HashRouter } from 'react-router-dom'

import './App.scss';
import { myTheme } from './assets/styles/my-theme'

import { initializeIcons, ThemeProvider } from '@fluentui/react';
import { initializeFileTypeIcons } from '@fluentui/react-file-type-icons';

import Layout from './components/Layout/Layout'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fas } from '@fortawesome/pro-solid-svg-icons'

import PrimeReact from 'primereact/api';
import { AbilityContext } from './shared/CASL/can';
import abilityBuild from './shared/CASL/appAbility';

library.add(fal, far, fas)

initializeIcons();
initializeFileTypeIcons();

class App extends Component {

    render() {
        PrimeReact.ripple = true;
        return (
            <ThemeProvider theme={myTheme}>
                <HashRouter>
                    <AbilityContext.Provider value={abilityBuild}>
                        <Layout />
                    </AbilityContext.Provider>
                </HashRouter>
            </ThemeProvider>
        );
    }
}

export default App;

